import styled, { css, keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const skeletonStyles = css`
  animation: ${shimmer} var(--dcm-skeleton-animation-duration) ease-in-out infinite;
  background: linear-gradient(
    90deg,
    ${({ theme }) =>
        theme.customized.utils.isNavBarDark
          ? 'var(--dcm-skeleton-shimmer-dark-from)'
          : 'var(--dcm-skeleton-shimmer-from)'}
      0px,
    ${({ theme }) =>
        theme.customized.utils.isNavBarDark ? 'var(--dcm-skeleton-shimmer-dark-to)' : 'var(--dcm-skeleton-shimmer-to)'}
      40px,
    ${({ theme }) =>
        theme.customized.utils.isNavBarDark
          ? 'var(--dcm-skeleton-shimmer-dark-from)'
          : 'var(--dcm-skeleton-shimmer-from)'}
      80px
  );
  background-size: 200px 100%;
  border-radius: var(--dcm-skeleton-border-radius);
`;

// Desktop styles
export const DesktopWrapper = styled.div`
  background: var(--dcm-header-bg);
  border-bottom: var(--dcm-header-border-width) solid var(--dcm-header-border-color);

  @media (max-width: 879px) {
    display: none;
  }
`;

export const DesktopContainer = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  justify-content: space-between;
  margin: 0 auto;
  max-width: var(--dcm-header-max-width);
  padding: 0 var(--dcm-header-padding-x);
  position: relative;
  width: 100%;
`;

export const DesktopNav = styled.nav`
  align-items: center;
  display: flex;
  flex: 1;
  gap: var(--dcm-header-gap);
  min-height: var(--dcm-header-min-height);
`;

export const DesktopUtilityNav = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  position: relative;
`;

export const DesktopInBetweenMq = styled.div`
  @media (min-width: 880px) and (max-width: 1019px) {
    display: none;
  }

  @media (min-width: 1020px) {
    align-items: center;
    display: flex;
    gap: var(--dcm-header-gap);
  }
`;

// Mobile styles
export const MobileWrapper = styled.div`
  background: var(--dcm-header-bg);
  border-bottom: var(--dcm-header-border-width) solid var(--dcm-header-border-color);
  padding: var(--dcm-header-mobile-padding-x);

  @media (min-width: 880px) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

export const MobileUtilityNav = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  position: relative;
`;

// Skeleton elements
export const SkeletonNavItem = styled.div`
  ${skeletonStyles}
  height: 20px;
  width: 50px;
`;

export const SkeletonMenuButton = styled.div`
  ${skeletonStyles}
  height: 24px;
  width: 70px;
`;

export const SkeletonSearchButton = styled.div`
  ${skeletonStyles}
  height: 20px;
  width: 65px;
`;

export const SkeletonSearchContainer = styled.div`
  flex: 1;
`;

export const SkeletonUserButton = styled.div`
  ${skeletonStyles}
  height: 24px;
  width: 24px;
  border-radius: 50%;
`;

export const SkeletonCartButton = styled.div`
  ${skeletonStyles}
  border-radius: var(--dcm-cart-btn-border-radius);
  height: var(--dcm-cart-btn-height);
  width: var(--dcm-cart-btn-width);

  @media (min-width: 880px) {
    height: var(--dcm-cart-btn-height-desktop);
    width: var(--dcm-cart-btn-width-desktop);
  }
`;

export const SkeletonStoreStatus = styled.div`
  ${skeletonStyles}
  height: 18px;
  width: 80px;
`;

export const SkeletonMenuType = styled.div`
  ${skeletonStyles}
  height: 18px;
  width: 60px;
`;

export const Divider = styled.div`
  border-left: 1px solid var(--dcm-header-divider-color);
  height: var(--dcm-header-divider-height);
`;
